import Form, { type CTA, type Input } from "~/components/newsletter/form";
import clx from "~/sdk/clx";
import { type FnContext as FnContext } from "~/types/deco";
export interface Props {
    /**
     * @title Título
     * @format html
     */
    title: string;
    /**
     * @title Título mobile
     * @format html
     */
    titleMobile: string;
    /**
     * @title Descrição
     * @format html
     */
    description: string;
    /**
     * @title Campos
     */
    inputs: Input[];
    cta: CTA;
    /**
     * @title Texto de finalização
     * @description Texto que aparecerá após o usuário assinar a newsletter
     * @format html
     */
    feedback: string;
    /**
     * @title Exibir borda do topo
     */
    borderTop?: boolean;
    /**
     * @title Exibir borda da base
     */
    borderBottom?: boolean;
    /**
     * @title Ocultar formulário
     */
    hideForm?: boolean;
    /**
     * @title Usar um fundo preto no mobile?
     * @description Não usado. Mantido só para não quebrar o CMS. A newsletter usa bege em desktop e mobile.
     */
    blackBg?: boolean;
}
// Tudo pronto! Agora é só aproveitar o seu Cupom: NEWS5 - Pedido mínimo de R$ 150.
export default function Newsletter({ title, titleMobile, description, inputs, cta, feedback, borderTop, borderBottom, hideForm, isMobile, }: ReturnType<typeof loader>) {
    const titleHtml = isMobile ? titleMobile || title : title;

    return (<div className={clx('p-[10px] border-salmon bg-bege flex items-center', borderTop && !isMobile && 'border-t-[10px]', borderBottom && 'border-b-[10px]')}>
            <div className={clx('flex justify-center items-center text-center mx-auto max-w-5xl w-full', isMobile ? 'flex-col' : 'flex-col lg:flex-row lg:gap-4')}>
                <div className={clx('flex w-full h-full justify-center items-center', isMobile ? 'flex-col' : 'flex-col lg:flex-row')}>
                    {titleHtml && (<div className={clx('w-full text-center text-[#91153a] font-bold leading-[1.2]', isMobile
                    ? 'mb-2 [&_p]:!text-center [&_p]:!mx-auto [&_span]:!text-center [&_strong]:!text-center [&_div]:!text-center'
                    : 'shrink-0 max-lg:mb-2 lg:mr-6 lg:w-auto lg:text-xl lg:leading-[1.75rem]')} dangerouslySetInnerHTML={{ __html: titleHtml }}/>)}

                    {!hideForm && description && (<div className={clx('text-xs w-full font-medium text-center text-wine [&_strong]:font-bold leading-none', isMobile
                    ? '[&_p]:!text-center [&_span]:!text-center'
                    : 'lg:text-base lg:leading-[1.5rem] lg:max-w-[20rem]')} dangerouslySetInnerHTML={{ __html: description }}/>)}
                </div>

                {!hideForm && (<div className={clx('w-full', isMobile && 'mt-3', !isMobile && 'max-lg:mt-3')}>
                        <Form inputs={inputs} cta={cta} feedback={feedback}/>
                    </div>)}
            </div>
        </div>);
}
export const loader = (props: Props, _: Request, ctx: FnContext) => {
    return {
        ...props,
        isMobile: ctx.device !== 'desktop',
    };
};
